// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* === PLAYER COM VISIBILIDADE CONTÍNUA (correção do desaparecimento) === */
.player {
  position: absolute;
  width: 128px; /* Aumentado de 128px para 160px */
  height: 128px; /* Aumentado de 128px para 160px */
  pointer-events: none;
  overflow: visible;
  
  /* === PROTEÇÕES CONTRA DESAPARECIMENTO === */
  /* Garantir que o player permaneça sempre visível (exceto durante animações especiais) */
  opacity: 1;
  visibility: visible;
  display: block !important;
  
  /* Evitar problemas de z-index - valor mínimo garantido */
  z-index: 1000;
  
  /* === OTIMIZAÇÕES DE RENDERIZAÇÃO === */
  /* Melhorar performance e evitar flickering */
  backface-visibility: hidden;
  image-rendering: pixelated;
  -webkit-user-select: none;
          user-select: none;
  
  /* === PROTEÇÕES CONTRA PROBLEMAS DE LAYOUT === */
  /* Evitar que transformações CSS causem desaparecimento */
  /* contain: layout style paint; */ /* REMOVIDO: impede overflow do conteúdo escalado */
  will-change: transform, left, top;
  
  /* 
    NOTA: Transições e transform são controlados dinamicamente via JavaScript
    para permitir animação suave customizada durante movimento
  */
}

/* === EXCEÇÃO: Permitir animações do Portal de Desmaterialização no container === */
.player.portal-dematerializing,
.player.portal-rematerializing {
  /* Permitir que pseudo-elementos e animações controlem a aparência */
  opacity: unset;
  visibility: unset;
}

/* Indicador de jogador ativo */
.player.active-player::after {
  content: "";
  position: absolute;
  bottom: -5px;
  left: 50%;
  transform: translateX(-50%);
  width: 32px;
  height: 32px;
  background: radial-gradient(circle, rgba(76,175,80,0.6) 0%, rgba(76,175,80,0) 70%);
  border-radius: 50%;
  animation: pulse-active 1.5s infinite alternate;
}

.player-active-indicator {
  position: absolute;
  top: 0px;
  left: 50%;
  transform: translateX(-50%);
  width: 12px;
  height: 12px;
  background-color: rgba(76, 175, 80, 0.8);
  border-radius: 50%;
  border: 2px solid white;
  box-shadow: 0 0 10px rgba(76, 175, 80, 0.8);
  animation: pulse-indicator 1.5s infinite alternate;
  z-index: 1001;
  opacity: 0.5;
}

.player-sprite {
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 100% 100%; /* Reduzir sprites 512x512 para caber no container 128x128 */
  background-position: center;
  
  /* === PROTEÇÕES CONTRA DESAPARECIMENTO DO SPRITE === */
  /* NOTA: opacity e visibility são controlados por padrão, mas podem ser sobrescritos
     por animações específicas (ex: portal de desmaterialização) */
  opacity: 1;
  visibility: visible;
  display: block !important;
  
  /* === OTIMIZAÇÕES DE RENDERIZAÇÃO === */
  transform: translateZ(0); /* Combinar scale com GPU acceleration */
  backface-visibility: hidden;
  image-rendering: pixelated;
  
  /* === PROTEÇÕES CONTRA PROBLEMAS DE LAYOUT === */
  /* Evitar que mudanças de background causem flickering */
  /* contain: layout style paint; */ /* REMOVIDO: impede overflow do conteúdo escalado */
  will-change: background-image;
}

/* === EXCEÇÃO: Animações do Portal de Desmaterialização === */
/* Permitir que as animações controlem opacity e outros atributos */
.player.portal-dematerializing .player-sprite,
.player.portal-rematerializing .player-sprite {
  /* Remover proteções que impedem a animação */
  opacity: unset;
  visibility: unset;
}

/* === AJUSTE ESPECÍFICO PARA SPRITES POR PERSONAGEM === */
/* Configuração centralizada está em src/utils/spriteSystem.ts -> CHARACTER_SPRITE_CONFIG */

.character-negra .player-sprite,
.character-maria .player-sprite,
.character-caio .player-sprite,
.character-tiabel .player-sprite,
.character-tiabel_victory .player-sprite,
.character-tiabel36 .player-sprite,
.character-thiago .player-sprite,
.character-joao .player-sprite,
.character-julia .player-sprite,
.character-larissa .player-sprite {
  /* Sprites negra/maria/caio/tiabel/tiabel_victory/tiabel36: 512x512px -> 50% para caber no container 128x128 */
  background-size: contain !important;
  background-position: center !important;
}

/* Aumenta o sprite da Tiabel (parada e animada) em 1.5x, sem mexer no container .player */
.character-tiabel .player-sprite,
.character-tiabel_victory .player-sprite {
  transform: translateZ(0) scale(1.3);
  transform-origin: center bottom; /* Ajuste fino: mantém os pés próximos ao tile */
}
.character-tiabel36 .player-sprite {
  transform: translateZ(0) scale(1.6);
  transform-origin: center bottom; /* Ajuste fino: mantém os pés próximos ao tile */
}


/* Container específico da Tiabel - NÃO escalar aqui pois já escalamos o sprite */
.tiabel-container {
  overflow: visible !important;
  isolation: isolate; /* Cria novo contexto de empilhamento */
  contain: none; /* Remove qualquer contenção que possa interferir */
}

/* Aplicar overflow visible especificamente no .player dentro do .tiabel-container */
.tiabel-container .player {
  overflow: visible !important;
  contain: none !important; /* Remove contenção que impede overflow */
}

.character-ana .player-sprite {
  /* Sprites ana: 256x256px -> 50% para caber no container 128x128 com scale(2) */
  background-size: contain !important;
  background-position: center !important;
}

/*
.player::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  /* box-shadow: 0 0 15px 5px rgba(255, 235, 59, 0.6); * /
  border-radius: 50%;
  /* animation: pulse-glow 1.5s infinite alternate; * /
}

.player::before {
  content: "";
  position: absolute;
  bottom: -1.5px;
  left: 50%;
  transform: translateX(-50%);
  width: 24px;
  height: 10px;
  background: radial-gradient(ellipse at center, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0) 70%);
  border-radius: 50%;
}
*/

.player-debug {
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: bold;
  white-space: nowrap;
  pointer-events: none;
  z-index: 1000;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
}

/* Direções do jogador */

/* sprites do player * /
.player-down .player-sprite {
  background-image: url('/assets/sprites/player0.png');
}

.player-left .player-sprite {
  background-image: url('/assets/sprites/player1.png');
}

.player-right .player-sprite {
  background-image: url('/assets/sprites/player2.png');
}

.player-up .player-sprite {
  background-image: url('/assets/sprites/player3.png');
}
*/

/*
.player-left-0 .player-sprite,
.player-up-0 .player-sprite  {
  background-image: url('/assets/sprites/laranjinha/Laranjinha_back_0.png');
}

.player-left-1 .player-sprite,
.player-up-1 .player-sprite  {
  background-image: url('/assets/sprites/laranjinha/Laranjinha_back_1.png');
}

.player-left-2 .player-sprite,
.player-up-2 .player-sprite  {
  background-image: url('/assets/sprites/laranjinha/Laranjinha_back_2.png');
} 

.player-left-3 .player-sprite,
.player-up-3 .player-sprite  {
  background-image: url('/assets/sprites/laranjinha/Laranjinha_back_3.png');
}

.player-left-4 .player-sprite,
.player-up-4 .player-sprite  {
  background-image: url('/assets/sprites/laranjinha/Laranjinha_back_4.png');
} 

.player-left-5 .player-sprite,
.player-up-5 .player-sprite  {
  background-image: url('/assets/sprites/laranjinha/Laranjinha_back_5.png');
}

.player-right-0 .player-sprite,
.player-down-0 .player-sprite  {
  background-image: url('/assets/sprites/laranjinha/Laranjinha_0.png');
}

.player-right-1 .player-sprite,
.player-down-1 .player-sprite  {
  background-image: url('/assets/sprites/laranjinha/Laranjinha_1.png');
}

.player-right-2 .player-sprite,
.player-down-2 .player-sprite  {
  background-image: url('/assets/sprites/laranjinha/Laranjinha_2.png');
}

.player-right-3 .player-sprite,
.player-down-3 .player-sprite  {
  background-image: url('/assets/sprites/laranjinha/Laranjinha_3.png');
} 

.player-right-4 .player-sprite,
.player-down-4 .player-sprite  {
  background-image: url('/assets/sprites/laranjinha/Laranjinha_4.png');
}

.player-right-5 .player-sprite,
.player-down-5 .player-sprite  {
  background-image: url('/assets/sprites/laranjinha/Laranjinha_5.png');
} 

*/

/* === SISTEMA ORTOGONAL DE SPRITES USANDO CSS DINÂMICO === */

/* 
  NOTA IMPORTANTE: Este sistema é complementado por JavaScript que gera
  dinamicamente as regras CSS para cada personagem, direção e frame.
  
  O formato da URL é construído em JavaScript seguindo o padrão:
  '/assets/sprites/<personagem>/<personagem>_<pasta_da_direcao>_<indice_frame_formatado>.png'
  
  As regras CSS específicas são inseridas dinamicamente no <style> tag
  para manter a ortogonalidade sem repetição de código.
*/

/* === CSS DINÂMICO SERÁ INSERIDO AQUI ===
 * As regras CSS específicas são geradas automaticamente pelo sistema ortogonal
 * e inseridas via JavaScript no formato:
 * .character-<personagem>.player-<direção>-<frame> .player-sprite { background-image: url(...); }
 */

/* === ANIMAÇÕES === */
/* Animações desabilitadas para evitar conflitos com animação customizada */
/* As animações de movimento são controladas via JavaScript para melhor performance */

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-2px);
  }
}

@keyframes idle {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-1px);
  }
}

@keyframes pulse-glow {
  0% {
    opacity: 0.4;
    box-shadow: 0 0 5px 2px rgba(255, 235, 59, 0.4);
  }
  100% {
    opacity: 0.8;
    box-shadow: 0 0 20px 10px rgba(255, 235, 59, 0.8);
  }
} 

@keyframes pulse-active {
  0% {
    opacity: 0.3;
    transform: translateX(-50%) scale(0.8);
  }
  100% {
    opacity: 0.7;
    transform: translateX(-50%) scale(1.2);
  }
}

@keyframes pulse-indicator {
  0% {
    box-shadow: 0 0 5px rgba(76, 175, 80, 0.6);
    transform: translateX(-50%) scale(0.95);
  }
  100% {
    box-shadow: 0 0 12px rgba(76, 175, 80, 0.8);
    transform: translateX(-50%) scale(1.05);
  }
}

/*
Aplicar scala=2 no  sprite do player em mobile e scala=3 no sprite do player em tablet
*/

/* Media queries removidas - tamanho do sprite agora é consistente */
/* O scale(2) no .player-sprite já proporciona o tamanho adequado */

/* === ANIMAÇÃO SIMPLES DE SALTO PARA TIABEL === */
/* @keyframes tiabel-celebration {
  0%, 20% {
    transform: translateY(0px);
  }
  10% {
    transform: translateY(-20px);
  }
  20%, 40% {
    transform: translateY(0px);
  }
  30% {
    transform: translateY(-20px);
  }
  40%, 60% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-20px);
  }
  60%, 80% {
    transform: translateY(0px);
  }
  70% {
    transform: translateY(-20px);
  }
  80%, 100% {
    transform: translateY(0px);
  }
  90% {
    transform: translateY(-20px);
  }
} */

@keyframes tiabel-celebration {
  0%, 100% {
    transform: translateY(0px);
  }
}

/* Classe para aplicar a celebração completa */
.tiabel-celebrating {
  animation: tiabel-celebration 5s ease-in-out;
}
`, "",{"version":3,"sources":["webpack://./src/components/Player.css"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E;EACE,kBAAkB;EAClB,YAAY,EAAE,kCAAkC;EAChD,aAAa,EAAE,kCAAkC;EACjD,oBAAoB;EACpB,iBAAiB;;EAEjB,6CAA6C;EAC7C,wFAAwF;EACxF,UAAU;EACV,mBAAmB;EACnB,yBAAyB;;EAEzB,yDAAyD;EACzD,aAAa;;EAEb,wCAAwC;EACxC,6CAA6C;EAC7C,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAiB;UAAjB,iBAAiB;;EAEjB,iDAAiD;EACjD,yDAAyD;EACzD,iCAAiC,EAAE,mDAAmD;EACtF,iCAAiC;;EAEjC;;;GAGC;AACH;;AAEA,oFAAoF;AACpF;;EAEE,oEAAoE;EACpE,cAAc;EACd,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,kFAAkF;EAClF,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,kBAAkB;EAClB,uBAAuB;EACvB,2CAA2C;EAC3C,kDAAkD;EAClD,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,0BAA0B,EAAE,4DAA4D;EACxF,2BAA2B;;EAE3B,uDAAuD;EACvD;kEACgE;EAChE,UAAU;EACV,mBAAmB;EACnB,yBAAyB;;EAEzB,wCAAwC;EACxC,wBAAwB,EAAE,wCAAwC;EAClE,2BAA2B;EAC3B,0BAA0B;;EAE1B,iDAAiD;EACjD,wDAAwD;EACxD,iCAAiC,EAAE,mDAAmD;EACtF,6BAA6B;AAC/B;;AAEA,8DAA8D;AAC9D,mEAAmE;AACnE;;EAEE,6CAA6C;EAC7C,cAAc;EACd,iBAAiB;AACnB;;AAEA,0DAA0D;AAC1D,2FAA2F;;AAE3F;;;;;;;;;;EAUE,8GAA8G;EAC9G,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA,0FAA0F;AAC1F;;EAEE,mCAAmC;EACnC,+BAA+B,EAAE,gDAAgD;AACnF;AACA;EACE,mCAAmC;EACnC,+BAA+B,EAAE,gDAAgD;AACnF;;;AAGA,iFAAiF;AACjF;EACE,4BAA4B;EAC5B,kBAAkB,EAAE,uCAAuC;EAC3D,aAAa,EAAE,mDAAmD;AACpE;;AAEA,oFAAoF;AACpF;EACE,4BAA4B;EAC5B,wBAAwB,EAAE,yCAAyC;AACrE;;AAEA;EACE,+EAA+E;EAC/E,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;CAwBC;;AAED;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,oCAAoC;EACpC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,sCAAsC;AACxC;;AAEA,wBAAwB;;AAExB;;;;;;;;;;;;;;;;CAgBC;;AAED;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA6DC;;AAED,6DAA6D;;AAE7D;;;;;;;;;CASC;;AAED;;;;EAIE;;AAEF,sBAAsB;AACtB,2EAA2E;AAC3E,qFAAqF;;AAErF;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,YAAY;IACZ,+CAA+C;EACjD;EACA;IACE,YAAY;IACZ,iDAAiD;EACnD;AACF;;AAEA;EACE;IACE,YAAY;IACZ,sCAAsC;EACxC;EACA;IACE,YAAY;IACZ,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,0CAA0C;IAC1C,uCAAuC;EACzC;EACA;IACE,2CAA2C;IAC3C,uCAAuC;EACzC;AACF;;AAEA;;CAEC;;AAED,oEAAoE;AACpE,mEAAmE;;AAEnE,kDAAkD;AAClD;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA+BG;;AAEH;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA,8CAA8C;AAC9C;EACE,4CAA4C;AAC9C","sourcesContent":["/* === PLAYER COM VISIBILIDADE CONTÍNUA (correção do desaparecimento) === */\r\n.player {\r\n  position: absolute;\r\n  width: 128px; /* Aumentado de 128px para 160px */\r\n  height: 128px; /* Aumentado de 128px para 160px */\r\n  pointer-events: none;\r\n  overflow: visible;\r\n  \r\n  /* === PROTEÇÕES CONTRA DESAPARECIMENTO === */\r\n  /* Garantir que o player permaneça sempre visível (exceto durante animações especiais) */\r\n  opacity: 1;\r\n  visibility: visible;\r\n  display: block !important;\r\n  \r\n  /* Evitar problemas de z-index - valor mínimo garantido */\r\n  z-index: 1000;\r\n  \r\n  /* === OTIMIZAÇÕES DE RENDERIZAÇÃO === */\r\n  /* Melhorar performance e evitar flickering */\r\n  backface-visibility: hidden;\r\n  image-rendering: pixelated;\r\n  user-select: none;\r\n  \r\n  /* === PROTEÇÕES CONTRA PROBLEMAS DE LAYOUT === */\r\n  /* Evitar que transformações CSS causem desaparecimento */\r\n  /* contain: layout style paint; */ /* REMOVIDO: impede overflow do conteúdo escalado */\r\n  will-change: transform, left, top;\r\n  \r\n  /* \r\n    NOTA: Transições e transform são controlados dinamicamente via JavaScript\r\n    para permitir animação suave customizada durante movimento\r\n  */\r\n}\r\n\r\n/* === EXCEÇÃO: Permitir animações do Portal de Desmaterialização no container === */\r\n.player.portal-dematerializing,\r\n.player.portal-rematerializing {\r\n  /* Permitir que pseudo-elementos e animações controlem a aparência */\r\n  opacity: unset;\r\n  visibility: unset;\r\n}\r\n\r\n/* Indicador de jogador ativo */\r\n.player.active-player::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  bottom: -5px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 32px;\r\n  height: 32px;\r\n  background: radial-gradient(circle, rgba(76,175,80,0.6) 0%, rgba(76,175,80,0) 70%);\r\n  border-radius: 50%;\r\n  animation: pulse-active 1.5s infinite alternate;\r\n}\r\n\r\n.player-active-indicator {\r\n  position: absolute;\r\n  top: 0px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 12px;\r\n  height: 12px;\r\n  background-color: rgba(76, 175, 80, 0.8);\r\n  border-radius: 50%;\r\n  border: 2px solid white;\r\n  box-shadow: 0 0 10px rgba(76, 175, 80, 0.8);\r\n  animation: pulse-indicator 1.5s infinite alternate;\r\n  z-index: 1001;\r\n  opacity: 0.5;\r\n}\r\n\r\n.player-sprite {\r\n  width: 100%;\r\n  height: 100%;\r\n  background-repeat: no-repeat;\r\n  background-size: 100% 100%; /* Reduzir sprites 512x512 para caber no container 128x128 */\r\n  background-position: center;\r\n  \r\n  /* === PROTEÇÕES CONTRA DESAPARECIMENTO DO SPRITE === */\r\n  /* NOTA: opacity e visibility são controlados por padrão, mas podem ser sobrescritos\r\n     por animações específicas (ex: portal de desmaterialização) */\r\n  opacity: 1;\r\n  visibility: visible;\r\n  display: block !important;\r\n  \r\n  /* === OTIMIZAÇÕES DE RENDERIZAÇÃO === */\r\n  transform: translateZ(0); /* Combinar scale com GPU acceleration */\r\n  backface-visibility: hidden;\r\n  image-rendering: pixelated;\r\n  \r\n  /* === PROTEÇÕES CONTRA PROBLEMAS DE LAYOUT === */\r\n  /* Evitar que mudanças de background causem flickering */\r\n  /* contain: layout style paint; */ /* REMOVIDO: impede overflow do conteúdo escalado */\r\n  will-change: background-image;\r\n}\r\n\r\n/* === EXCEÇÃO: Animações do Portal de Desmaterialização === */\r\n/* Permitir que as animações controlem opacity e outros atributos */\r\n.player.portal-dematerializing .player-sprite,\r\n.player.portal-rematerializing .player-sprite {\r\n  /* Remover proteções que impedem a animação */\r\n  opacity: unset;\r\n  visibility: unset;\r\n}\r\n\r\n/* === AJUSTE ESPECÍFICO PARA SPRITES POR PERSONAGEM === */\r\n/* Configuração centralizada está em src/utils/spriteSystem.ts -> CHARACTER_SPRITE_CONFIG */\r\n\r\n.character-negra .player-sprite,\r\n.character-maria .player-sprite,\r\n.character-caio .player-sprite,\r\n.character-tiabel .player-sprite,\r\n.character-tiabel_victory .player-sprite,\r\n.character-tiabel36 .player-sprite,\r\n.character-thiago .player-sprite,\r\n.character-joao .player-sprite,\r\n.character-julia .player-sprite,\r\n.character-larissa .player-sprite {\r\n  /* Sprites negra/maria/caio/tiabel/tiabel_victory/tiabel36: 512x512px -> 50% para caber no container 128x128 */\r\n  background-size: contain !important;\r\n  background-position: center !important;\r\n}\r\n\r\n/* Aumenta o sprite da Tiabel (parada e animada) em 1.5x, sem mexer no container .player */\r\n.character-tiabel .player-sprite,\r\n.character-tiabel_victory .player-sprite {\r\n  transform: translateZ(0) scale(1.3);\r\n  transform-origin: center bottom; /* Ajuste fino: mantém os pés próximos ao tile */\r\n}\r\n.character-tiabel36 .player-sprite {\r\n  transform: translateZ(0) scale(1.6);\r\n  transform-origin: center bottom; /* Ajuste fino: mantém os pés próximos ao tile */\r\n}\r\n\r\n\r\n/* Container específico da Tiabel - NÃO escalar aqui pois já escalamos o sprite */\r\n.tiabel-container {\r\n  overflow: visible !important;\r\n  isolation: isolate; /* Cria novo contexto de empilhamento */\r\n  contain: none; /* Remove qualquer contenção que possa interferir */\r\n}\r\n\r\n/* Aplicar overflow visible especificamente no .player dentro do .tiabel-container */\r\n.tiabel-container .player {\r\n  overflow: visible !important;\r\n  contain: none !important; /* Remove contenção que impede overflow */\r\n}\r\n\r\n.character-ana .player-sprite {\r\n  /* Sprites ana: 256x256px -> 50% para caber no container 128x128 com scale(2) */\r\n  background-size: contain !important;\r\n  background-position: center !important;\r\n}\r\n\r\n/*\r\n.player::after {\r\n  content: \"\";\r\n  position: absolute;\r\n  width: 100%;\r\n  height: 100%;\r\n  top: 0;\r\n  left: 0;\r\n  /* box-shadow: 0 0 15px 5px rgba(255, 235, 59, 0.6); * /\r\n  border-radius: 50%;\r\n  /* animation: pulse-glow 1.5s infinite alternate; * /\r\n}\r\n\r\n.player::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  bottom: -1.5px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  width: 24px;\r\n  height: 10px;\r\n  background: radial-gradient(ellipse at center, rgba(0,0,0,0.6) 0%, rgba(0,0,0,0) 70%);\r\n  border-radius: 50%;\r\n}\r\n*/\r\n\r\n.player-debug {\r\n  position: absolute;\r\n  top: -25px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  background-color: rgba(0, 0, 0, 0.8);\r\n  color: white;\r\n  padding: 3px 8px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  font-weight: bold;\r\n  white-space: nowrap;\r\n  pointer-events: none;\r\n  z-index: 1000;\r\n  box-shadow: 0 0 5px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n/* Direções do jogador */\r\n\r\n/* sprites do player * /\r\n.player-down .player-sprite {\r\n  background-image: url('/assets/sprites/player0.png');\r\n}\r\n\r\n.player-left .player-sprite {\r\n  background-image: url('/assets/sprites/player1.png');\r\n}\r\n\r\n.player-right .player-sprite {\r\n  background-image: url('/assets/sprites/player2.png');\r\n}\r\n\r\n.player-up .player-sprite {\r\n  background-image: url('/assets/sprites/player3.png');\r\n}\r\n*/\r\n\r\n/*\r\n.player-left-0 .player-sprite,\r\n.player-up-0 .player-sprite  {\r\n  background-image: url('/assets/sprites/laranjinha/Laranjinha_back_0.png');\r\n}\r\n\r\n.player-left-1 .player-sprite,\r\n.player-up-1 .player-sprite  {\r\n  background-image: url('/assets/sprites/laranjinha/Laranjinha_back_1.png');\r\n}\r\n\r\n.player-left-2 .player-sprite,\r\n.player-up-2 .player-sprite  {\r\n  background-image: url('/assets/sprites/laranjinha/Laranjinha_back_2.png');\r\n} \r\n\r\n.player-left-3 .player-sprite,\r\n.player-up-3 .player-sprite  {\r\n  background-image: url('/assets/sprites/laranjinha/Laranjinha_back_3.png');\r\n}\r\n\r\n.player-left-4 .player-sprite,\r\n.player-up-4 .player-sprite  {\r\n  background-image: url('/assets/sprites/laranjinha/Laranjinha_back_4.png');\r\n} \r\n\r\n.player-left-5 .player-sprite,\r\n.player-up-5 .player-sprite  {\r\n  background-image: url('/assets/sprites/laranjinha/Laranjinha_back_5.png');\r\n}\r\n\r\n.player-right-0 .player-sprite,\r\n.player-down-0 .player-sprite  {\r\n  background-image: url('/assets/sprites/laranjinha/Laranjinha_0.png');\r\n}\r\n\r\n.player-right-1 .player-sprite,\r\n.player-down-1 .player-sprite  {\r\n  background-image: url('/assets/sprites/laranjinha/Laranjinha_1.png');\r\n}\r\n\r\n.player-right-2 .player-sprite,\r\n.player-down-2 .player-sprite  {\r\n  background-image: url('/assets/sprites/laranjinha/Laranjinha_2.png');\r\n}\r\n\r\n.player-right-3 .player-sprite,\r\n.player-down-3 .player-sprite  {\r\n  background-image: url('/assets/sprites/laranjinha/Laranjinha_3.png');\r\n} \r\n\r\n.player-right-4 .player-sprite,\r\n.player-down-4 .player-sprite  {\r\n  background-image: url('/assets/sprites/laranjinha/Laranjinha_4.png');\r\n}\r\n\r\n.player-right-5 .player-sprite,\r\n.player-down-5 .player-sprite  {\r\n  background-image: url('/assets/sprites/laranjinha/Laranjinha_5.png');\r\n} \r\n\r\n*/\r\n\r\n/* === SISTEMA ORTOGONAL DE SPRITES USANDO CSS DINÂMICO === */\r\n\r\n/* \r\n  NOTA IMPORTANTE: Este sistema é complementado por JavaScript que gera\r\n  dinamicamente as regras CSS para cada personagem, direção e frame.\r\n  \r\n  O formato da URL é construído em JavaScript seguindo o padrão:\r\n  '/assets/sprites/<personagem>/<personagem>_<pasta_da_direcao>_<indice_frame_formatado>.png'\r\n  \r\n  As regras CSS específicas são inseridas dinamicamente no <style> tag\r\n  para manter a ortogonalidade sem repetição de código.\r\n*/\r\n\r\n/* === CSS DINÂMICO SERÁ INSERIDO AQUI ===\r\n * As regras CSS específicas são geradas automaticamente pelo sistema ortogonal\r\n * e inseridas via JavaScript no formato:\r\n * .character-<personagem>.player-<direção>-<frame> .player-sprite { background-image: url(...); }\r\n */\r\n\r\n/* === ANIMAÇÕES === */\r\n/* Animações desabilitadas para evitar conflitos com animação customizada */\r\n/* As animações de movimento são controladas via JavaScript para melhor performance */\r\n\r\n@keyframes bounce {\r\n  0%, 100% {\r\n    transform: translateY(0);\r\n  }\r\n  50% {\r\n    transform: translateY(-2px);\r\n  }\r\n}\r\n\r\n@keyframes idle {\r\n  0%, 100% {\r\n    transform: translateY(0);\r\n  }\r\n  50% {\r\n    transform: translateY(-1px);\r\n  }\r\n}\r\n\r\n@keyframes pulse-glow {\r\n  0% {\r\n    opacity: 0.4;\r\n    box-shadow: 0 0 5px 2px rgba(255, 235, 59, 0.4);\r\n  }\r\n  100% {\r\n    opacity: 0.8;\r\n    box-shadow: 0 0 20px 10px rgba(255, 235, 59, 0.8);\r\n  }\r\n} \r\n\r\n@keyframes pulse-active {\r\n  0% {\r\n    opacity: 0.3;\r\n    transform: translateX(-50%) scale(0.8);\r\n  }\r\n  100% {\r\n    opacity: 0.7;\r\n    transform: translateX(-50%) scale(1.2);\r\n  }\r\n}\r\n\r\n@keyframes pulse-indicator {\r\n  0% {\r\n    box-shadow: 0 0 5px rgba(76, 175, 80, 0.6);\r\n    transform: translateX(-50%) scale(0.95);\r\n  }\r\n  100% {\r\n    box-shadow: 0 0 12px rgba(76, 175, 80, 0.8);\r\n    transform: translateX(-50%) scale(1.05);\r\n  }\r\n}\r\n\r\n/*\r\nAplicar scala=2 no  sprite do player em mobile e scala=3 no sprite do player em tablet\r\n*/\r\n\r\n/* Media queries removidas - tamanho do sprite agora é consistente */\r\n/* O scale(2) no .player-sprite já proporciona o tamanho adequado */\r\n\r\n/* === ANIMAÇÃO SIMPLES DE SALTO PARA TIABEL === */\r\n/* @keyframes tiabel-celebration {\r\n  0%, 20% {\r\n    transform: translateY(0px);\r\n  }\r\n  10% {\r\n    transform: translateY(-20px);\r\n  }\r\n  20%, 40% {\r\n    transform: translateY(0px);\r\n  }\r\n  30% {\r\n    transform: translateY(-20px);\r\n  }\r\n  40%, 60% {\r\n    transform: translateY(0px);\r\n  }\r\n  50% {\r\n    transform: translateY(-20px);\r\n  }\r\n  60%, 80% {\r\n    transform: translateY(0px);\r\n  }\r\n  70% {\r\n    transform: translateY(-20px);\r\n  }\r\n  80%, 100% {\r\n    transform: translateY(0px);\r\n  }\r\n  90% {\r\n    transform: translateY(-20px);\r\n  }\r\n} */\r\n\r\n@keyframes tiabel-celebration {\r\n  0%, 100% {\r\n    transform: translateY(0px);\r\n  }\r\n}\r\n\r\n/* Classe para aplicar a celebração completa */\r\n.tiabel-celebrating {\r\n  animation: tiabel-celebration 5s ease-in-out;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
